import loadAddThis from "../../common/loadAddThis.js";
import NavMenu from "../../common/NavMenu.js";

export default () => {
  document.querySelectorAll(".js-share-bar").forEach((elShare, index) => {
    if (index === 0) {
      loadAddThis(elShare.dataset.pubId || "");
    }

    const elItems = elShare.querySelector(".js-share-bar-items"); 

    // set the max-width of the share items for animation affects
    elItems.setAttribute("style", `max-width: 100%`);

    // using forEach as a conditional selector
    elShare.querySelectorAll(".js-read-time").forEach((el, i) => {
      const wordsPerMinute = 200; // 200 is the average case.
      let textLength = 0;

      document.querySelectorAll(".js-rich-text > p").forEach((p) => {
        textLength = textLength + p.textContent.split(" ").length;
      });

      const readTimeMinutes =
        textLength > 0 ? Math.ceil(textLength / wordsPerMinute) : 0;

      el.innerText =
        readTimeMinutes > 60
          ? `${(readTimeMinutes / 60).toFixed(1)} hours`
          : `${readTimeMinutes} minutes`;
    });

    const menuConfig = {
      animationDelay: 350,
      closed: window.innerWidth < 680,
      reversed: true,
      direction: "horizontal",
      menuButton: ".js-share-bar-menu",
      menuContainer: ".js-share-bar-items",
      navigationLink: ".js-share-bar-items a",
      openClass: "is-open",
      onClose: closeShare,
      onOpen: openShare,
      parent: elShare,
    };

    const shareMenu = NavMenu(menuConfig);

    function closeShare() {
      elShare.classList.add("is-closed");
    }

    function openShare() {
      elShare.classList.remove("is-closed");
    }
  });
};
